import functions from '../functions';

// global datepicker init with automatic "dateTo" set if provided
let displayDate = new Date('2025-06-01');
let now = functions.cleanDate(new Date);
if (now > displayDate)
{
    displayDate = now;
}

$('.datepicker-range:not(.departure-picker-combined)').each((i, elem) =>
{
    const $datepicker = $(elem);
    let minDate = $datepicker.attr('data-min');
    let maxDate = $datepicker.attr('data-max');
    const arrival = $datepicker.attr('data-arrival') ? $datepicker.attr('data-arrival') : [];
    const defaultDate = $datepicker.attr('data-defaultDate') ? $datepicker.attr('data-defaultDate') : [];
    const duration = Number($datepicker.attr('data-duration'));
    const position = $datepicker.attr('data-position') || 'auto';
    const minStayText = $datepicker.attr('data-minstay');
    flatpickr.l10ns[functions.getLang()].rangeSeparator = ' - ';

    let availableDates = $datepicker.attr('data-availableDates');
    if (availableDates) {
        availableDates = JSON.parse(availableDates);
        minDate = new Date(availableDates[0].from);
        //maxDate = null;
    }

    $datepicker.flatpickr({
        mode: "range",
        showMonths: functions.isMobile() ? 1 : 2,
        altInput: true,
        wrap: true,
        altFormat: "j.m.Y",
        dateFormat: "Y-m-d",
        defaultDate: defaultDate,
        minDate: minDate && minDate >= now ? minDate : now,
        maxDate: maxDate ? maxDate : null,
        disableMobile: true,
        prevArrow: '<i class="fa-light fa-arrow-left fa-lg"></i>',
        nextArrow: '<i class="fa-light fa-arrow-right fa-lg"></i>',
        locale: flatpickr.l10ns[functions.getLang()],
        position: position,
        minStayText: minStayText ? minStayText : '',
        onDayCreate(dObj, dStr, fp, dayElem)
        {

            let minStay = 1;
            let to = new Date(maxDate);
            let weekday = new Date(dayElem.dateObj).getDay();
            weekday = '' + (weekday ? weekday : 7);
            to.setHours(0, 0, 0, 0);
            let onlyCheckInSelected = fp.selectedDates[0] && !fp.selectedDates[1];
            // let diff = globals.dateDiff(dayElem.dateObj, fp.selectedDates[0]);
            let from = dayElem.dateObj;
            let too = fp.selectedDates[0];
            // let f = Date.UTC(from.getFullYear(), from.getMonth()+1, from.getDate());
            // let t = Date.UTC(too.getFullYear(), too.getMonth()+1, too.getDate());

            let diff = Math.round((from - too) / (1000 * 60 * 60 * 24));

            if (onlyCheckInSelected)
            {
                if (Math.abs(diff) < minStay)
                {
                    dayElem.className += ' flatpickr-disabled ';
                    if (diff)
                    {
                        if (minStayText)
                        {
                            $(dayElem).tooltip({
                                title: minStayText.replace('{$min_stay}', minStay) || ''
                            });
                        }
                    }
                }
            }

            if (dayElem.dateObj > to || (arrival.length && $.inArray(weekday, arrival) == -1))
            {
                dayElem.classList.add('unselectable');
            }
        },
        onOpen: [
            function(selectedDates, dateStr, instance){
                $(instance.element).parents('.search-horizontal').find('.form-guide.form-control').removeClass('focused');
            },
        ],
        onClose: function(selectedDates, dateStr, instance){
            $(instance.element).find('.form-control.input').blur();
         }
    });

    if (availableDates) {
        $datepicker[0]._flatpickr.config.enable = availableDates;
    }
    // to style clear toggler
    //$datepicker.on('change', e => requestAnimationFrame(() => $(e.target).parent().toggleClass('datepicker-value', !!e.target.value)));
    $datepicker.on('change', e => {
        e.target.value.split(' - ').length > 1 && $(e.currentTarget).find('.form-control.input').removeClass('active') && $(e.currentTarget).parents('.search-horizontal').find('.input-guests.form-control').addClass('focused');
        requestAnimationFrame(() => $(e.target).parent().toggleClass('datepicker-value', !!e.target.value));
    });
});

/*$('.datepicker').each((i, elem) =>
{
    const $datepicker = $(elem);
    const minDate = $datepicker.attr('data-min');
    const maxDate = $datepicker.attr('data-max');
    $datepicker.flatpickr({
        altInput: true,
        wrap: true,
        altFormat: "j.m.Y",
        dateFormat: "Y-m-d",
        minDate: minDate ? minDate : now,
        maxDate: maxDate ? maxDate : null,
        disableMobile: true,
        prevArrow: '<i class="la la-angle-left pr-2"></i>',
        nextArrow: '<i class="la la-angle-right pl-2"></i>',
        onChange(selectedDates, dateStr, instance)
        {

            const $first = $(instance.input);
            // prevent other logic if second datepicker is triggered by first
            if (instance._openByFirst)
            {
                delete instance._openByFirst;
                return;
            }

            if ($first.attr('data-firstDate'))
            {
                const $second = $first.closest('form').find('[data-secondDate]').closest('.datepicker');
                if ($second.length)
                {

                    var firstDate = new Date(selectedDates[0]);
                    firstDate.setDate(firstDate.getDate() + 1);

                    var secondInstance = $second[0]._flatpickr;
                    // check if firstDate is invalid
                    if (firstDate.getTime() === firstDate.getTime())
                    {
                        secondInstance._openByFirst = true;
                        secondInstance.set('minDate', firstDate);
                        if (!secondInstance.selectedDates[0])
                        {
                            firstDate.setDate(firstDate.getDate() + 6);
                            secondInstance.setDate(firstDate);
                        }
                        secondInstance.open();
                        $(secondInstance.altInput).focus();
                    }
                    else if (secondInstance.selectedDates[0])
                    {
                        secondInstance.clear();
                    }
                }
            }
            // check if second date is cleared
            else if ($first.attr('data-secondDate') && !selectedDates[0])
            {
                $first.closest('form').find('[data-firstDate]').closest('.datepicker')[0]._flatpickr.clear();
            }
        },
        onOpen(selectedDates, dateStr, instance)
        {
            if (instance.input.getAttribute('data-secondDate'))
            {
                const $first = $(instance.input).closest('form').find('[data-firstDate]').closest('.datepicker');
                if ($first.length)
                {
                    const firstInstance = $first[0]._flatpickr;
                    if (!firstInstance.input.value)
                    {
                        instance.close();
                        firstInstance.open();
                        firstInstance.altInput.focus();
                        return;
                    }
                }
            }
            !dateStr && instance.jumpToDate(minDate ? minDate : displayDate);
        }
    });
    // to style clear toggler
    $datepicker.on('change', e => requestAnimationFrame(() => $(e.target).parent().toggleClass('datepicker-value', !!e.target.value)));
});*/
